import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const DEFAULT_IMAGE = 'https://www.impactisol.com/images/og-impactisol.jpg';

const SEO = ({ title, description, noindex = false, jsonLd, image = DEFAULT_IMAGE }) => {
  const location = useLocation();
  const baseUrl = 'https://www.impactisol.com';

  const path = location.pathname === '/' ? '' : location.pathname.replace(/\/$/, "");
  const canonicalUrl = `${baseUrl}${path}`;

  // Force noindex if we are on the Amplify domain to prevent duplicate indexing
  const currentHostname = typeof window !== 'undefined' ? window.location.hostname : '';
  const isAmplifyDomain = currentHostname.includes('amplifyapp.com');
  const shouldNoIndex = noindex || isAmplifyDomain;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />

      {shouldNoIndex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow" />
      )}

      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={image} />

      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
